import * as React from 'react';
export const oxxoSvg = React.forwardRef(function oxxoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E70020',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.994 20.456a1.983 1.983 0 0 0 1.976 1.99h20.045a1.984 1.984 0 0 0 1.978-1.99v-8.722a1.985 1.985 0 0 0-1.978-1.99H5.97a1.984 1.984 0 0 0-1.977 1.99v8.722Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.62 11.594c0-.7.562-1.268 1.257-1.268H26.13a1.263 1.263 0 0 1 1.256 1.269v.04H4.62v-.04m22.766 8.977v.03c0 .701-.562 1.27-1.256 1.27H5.876a1.263 1.263 0 0 1-1.256-1.27v-.03h22.766Z',
      fill: '#FBB110',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.375 16.085c0 1.772 1.424 3.21 3.181 3.21 1.756 0 3.18-1.438 3.18-3.21 0-1.774-1.424-3.21-3.18-3.21-1.757 0-3.18 1.437-3.18 3.21Zm-15.163 0c0 1.772 1.424 3.21 3.182 3.21 1.755 0 3.18-1.438 3.18-3.21 0-1.774-1.425-3.21-3.18-3.21-1.758 0-3.182 1.437-3.182 3.21Zm22.174 3.878H11.704c.283-.2.546-.473.833-.843l1.597-2.057.698.89.777-1.043-.679-.871 1.625-2.094c.517-.665-.47-1.446-.986-.782l-1.437 1.852-1.461-1.876c-.517-.662-1.502.12-.986.783l1.651 2.117-1.786 2.3c-.635.818-1.268 1.567-2.526 1.625H4.62v-7.722h15.6c-.269.198-.521.463-.796.816l-1.597 2.058-.698-.89-.776 1.043.68.871-1.627 2.094c-.516.664.47 1.445.987.78l1.438-1.85 1.46 1.875c.517.663 1.503-.12.986-.782l-1.651-2.118 1.786-2.3c.583-.751 1.165-1.445 2.232-1.596h4.742v7.72Zm-5.734-3.878a1.915 1.915 0 0 1 1.904-1.922 1.913 1.913 0 0 1 1.903 1.922 1.912 1.912 0 0 1-1.903 1.921 1.912 1.912 0 0 1-1.904-1.92Zm-15.162 0a1.913 1.913 0 0 1 1.904-1.922 1.913 1.913 0 0 1 1.902 1.922 1.913 1.913 0 0 1-1.903 1.921 1.912 1.912 0 0 1-1.903-1.92Z',
      fill: '#E70020',
    }),
  );
});
oxxoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var oxxo = {
  category: 'brand',
  colorable: false,
  name: 'oxxo',
  svg: oxxoSvg,
};
